module.exports = globalConf;


//////////////////
// WEBPACK FOOTER
// external "globalConf"
// module id = 29
// module chunks = 2